/*
 * Copyright (c) Worldline 2023.
 */

import {Injectable} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {SessionService} from "./session.service";
import {RedirectionService} from "./redirection.service";

@Injectable({
    providedIn: 'root'
})
export class CancelService {

    constructor(private sessionService: SessionService, private redirectionService: RedirectionService, private router: Router) {
    }

    confirmCancel(route: ActivatedRoute) {
        //redirect
        var sessionId = this.sessionService.id;

        this.redirectionService.confirmCancelation(route, sessionId);
    };

}
